import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import styled from '@mui/system/styled';
import theme from '@/mui/theme';

export interface ProductDetailTitleProps {
  occhiello?: string
  title?: string
  titleBigMobile?: boolean
}

const StyledOcchiello = styled(Typography)({
  color: "#ff5c04",
  fontSize: "22px",
  letterSpacing: "-0.45px",
  lineHeight: "28px",
  '&.centered-aligned': {
    textAlign: 'center'
  },
})

const StyledTitle = styled(Typography)({
  [theme.breakpoints.up('sm')]: {
    fontSize: "51px",
    letterSpacing: "0",
    lineHeight: "54px",
  },
  '&.title-big-mobile': {
    fontSize: "51px",
    letterSpacing: "0",
    lineHeight: "54px",
  },
  color: "#182641",
  fontSize: "24px",
  fontWeight: "bold",
  letterSpacing: "-0.1px",
  lineHeight: "30px",
  marginBottom: "30px",
})

const ProductDetailTitle: React.FC<ProductDetailTitleProps> = ({ occhiello, title, titleBigMobile }) => {
  const titleClass = titleBigMobile ? 'title-big-mobile' : undefined;
  return <Grid item xs={12} sx={{ marginTop: 0 }}>
    <Box>
      {occhiello &&
        <StyledOcchiello>{occhiello}</StyledOcchiello>
      }
      {title &&
        <StyledTitle className={titleClass}>{title}</StyledTitle>
      }
    </Box>
  </Grid>
}

export default ProductDetailTitle;
